import RecipeDetails, { RecipeDetailsProps } from "./RecipeDetails";

export { RecipeDetails, RecipeDetailsProps };

export default RecipeDetails;
